const ace = require('brace');
const Colors = require('@zapier/theme').Colors;

const batmobileRgb = '95, 108, 114';

ace.define(
  'ace/theme/zapier',
  ['require', 'exports', 'module', 'ace/lib/dom'],
  function (acequire, exports) {
    exports.isDark = true;
    exports.cssClass = 'ace-zapier';
    exports.cssText = `
    .ace-zapier {
      border-radius: 4px;
      font-size: 14px;
      font-family: 'Inconsolata', monospace
    }
    .ace-zapier .ace_gutter {
      padding-left: 4px;
    }
    .ace-zapier .ace_gutter {
      background: ${Colors.deepSpace};
      color: ${Colors.steel};
    }
    .ace-zapier .ace_scroller {
      border-radius: 4px;
    }
    .ace-zapier .ace_print-margin {
      width: 1px;
      background: ${Colors.deepSpace};
    }
    .ace-zapier {
      background-color: ${Colors.deepSpace};
      color: #cccccc;
    }
    .ace-zapier .ace_constant.ace_other,
    .ace-zapier .ace_cursor {
      color: #cccccc;
    }
    .ace-zapier .ace_marker-layer .ace_selection {
      background: rgba(${batmobileRgb}, 0.5);
    }
    .ace-zapier.ace_multiselect .ace_selection.ace_start {
      box-shadow: 0 0 3px 0px ${Colors.deepSpace};
    }
    .ace-zapier .ace_marker-layer .ace_selected-word {
      border: 1px solid rgba(${batmobileRgb}, 0.5);
    }
    .ace-zapier .ace_marker-layer .ace_step {
      background: rgb(102, 82, 0);
    }
    .ace-zapier .ace_marker-layer .ace_bracket {
      margin: -1px 0 0 -1px;
      border: 1px solid #6a6a6a;
    }
    .ace-zapier .ace_stack {
      background: rgb(66, 90, 44);
    }
    .ace-zapier .ace_marker-layer .ace_active-line {
      background: rgba(${batmobileRgb}, 0.3);
    }
    .ace-zapier .ace_gutter-active-line {
      background: rgba(${batmobileRgb}, 0.3);
    }
    .ace-zapier .ace_invisible {
      color: #6a6a6a;
    }
    .ace-zapier .ace_keyword,
    .ace-zapier .ace_meta,
    .ace-zapier .ace_storage,
    .ace-zapier .ace_storage.ace_type,
    .ace-zapier .ace_support.ace_type {
      color: #cc99cd;
    }
    .ace-zapier .ace_keyword.ace_operator {
      color: #66cccc;
    }
    .ace-zapier .ace_constant.ace_character,
    .ace-zapier .ace_constant.ace_language,
    .ace-zapier .ace_constant.ace_numeric,
    .ace-zapier .ace_keyword.ace_other.ace_unit,
    .ace-zapier .ace_support.ace_constant,
    .ace-zapier .ace_variable.ace_parameter {
      color: #f08d49;
    }
    .ace-zapier .ace_invalid {
      color: #cdcdcd;
      background-color: #f2777a;
    }
    .ace-zapier .ace_invalid.ace_deprecated {
      color: #cdcdcd;
      background-color: #cc99cd;
    }
    .ace-zapier .ace_fold {
      background-color: ${Colors.captainAmerica};
      border: none;
    }
    .ace-zapier .ace_entity.ace_name.ace_function,
    .ace-zapier .ace_support.ace_function,
    .ace-zapier .ace_variable {
      color: #6699cc;
    }
    .ace-zapier .ace_support.ace_class,
    .ace-zapier .ace_support.ace_type {
      color: #ffcc66;
    }
    .ace-zapier .ace_heading,
    .ace-zapier .ace_markup.ace_heading,
    .ace-zapier .ace_string {
      color: #7ec699;
    }
    .ace-zapier .ace_comment {
      color: #999;
    }
    .ace-zapier .ace_entity.ace_name.ace_tag,
    .ace-zapier .ace_entity.ace_other.ace_attribute-name,
    .ace-zapier .ace_meta.ace_tag,
    .ace-zapier .ace_variable {
      color: #f2777a;
    }
    .ace-zapier .ace_indent-guide {
      box-shadow: 1px 0 1px -2px ${Colors.batmobile};
    }
    `;

    const dom = acequire('../lib/dom');
    dom.importCssString(exports.cssText, exports.cssClass);
  }
);
